export class MethodNotDefinedError extends Error {
	/**
	 * @param {string | undefined} message - message for error
	 */
	constructor(message) {
		super(message);
		this.name = 'MethodNotDefinedError';
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, MethodNotDefinedError);
		}
	}
}

export class EntityNotDefined extends Error {
	/**
	 * @param {string | undefined} message - message for error
	 */
	constructor(message) {
		super(message);
		this.name = 'EntityNotDefinedError';
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, EntityNotDefined);
		}
	}
}

export class UnknownError extends Error {
	/**
	 * @param {string | {message?: string; parsedMessage?: string; } | unknown} error - message for error
	 */
	constructor(error) {
		const errorMessage = UnknownError.getMessage(error);
		super(errorMessage);
		this.name = 'UnknownError';
		this.errorCode = '777000';
		this.details = {};
		this.cause = error;
		this.originalMessage = this.message;

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, UnknownError);
		}
	}

	/**
	 * @param {string | {message: string;} | unknown} error - message for error
	 * @returns {string} errorMessage
	 */
	static getMessage(error) {
		if (typeof error === 'string') return error;
		if (error?.message === 'string') return error.message;
		return 'Unknown Error';
	}
}
